/**
   * Creates an array of elements split into groups the length of size.
   * If array can't be split evenly, the final chunk will be the remaining elements.
   * Taken from https://lodash.com/docs/4.17.15#chunk.
   * @param input T
   * @param size number
   * @returns T[][]
   */
export const chunk = <T extends unknown>(input: T[], size: number): T[][] => input.reduce((arr, item, idx) => (idx % size === 0
  ? [...arr, [item]]
  : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]]), []);
